require('./fieldValue.scss')

module.exports = {
  template: require('./fieldValue.pug')()
  controller: require('./fieldValue.ctrl')
  transclude: true
  bindings:
    label: '@'
}
